module.exports = __webpack_public_path__ + "img/BlendBuff-Earth.80d5a143.png";